module.exports = __webpack_public_path__ + "static/media/nurseBanner.3b73360b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurseBanner.jpg
// module id = 479
// module chunks = 0